import classNames from 'classnames'
import React, { ReactElement } from 'react'

import { getCloudinaryUrl } from 'core/classes/helpers'

import { banner_url, banner_webp_url } from './configs'

import styles from './APLHeader.module.scss'

interface IAPLHeaderProps {
  firstSlice: ReactElement
  secondSlice?: ReactElement
}

export const APLHeader = ({ firstSlice, secondSlice }: IAPLHeaderProps) => {
  const cloudinaryJPGParams = {
    src: banner_url,
  }

  const cloudinaryWEBPParams = {
    src: banner_webp_url,
  }

  const bannerJPGIMG = getCloudinaryUrl(cloudinaryJPGParams)
  const bannerWEBPIMG = getCloudinaryUrl(cloudinaryWEBPParams)

  return (
    <div className={styles.root}>
      <div className={styles.leftSide}>
        <div
          className={classNames(styles.leftSide__firstSlice, {
            [styles.leftSide__firstSlice__fullView]: !secondSlice,
          })}
        >
          {firstSlice}
        </div>
        {secondSlice ? <div className={styles.leftSide__secondSlice}>{secondSlice}</div> : null}
      </div>
      <div className={styles.rightSide}>
        <picture>
          <source srcSet={bannerJPGIMG} type="image/jpeg" />
          <source srcSet={bannerWEBPIMG} type="image/webp" />
          <img className={styles.rightSide__img} src={bannerJPGIMG} alt="simple_partner_landing" />
        </picture>
      </div>
    </div>
  )
}
